import { Text, Box, Stack } from 'braid-design-system';
import React from 'react';

import type { PageProps } from 'src/shared/types';

import { StaticPageProvider } from '../../../../components';
import { PageIntro } from '../../components';

import {
  SellingPoints,
  Highlights,
  RefundGuarantee,
  Testimonial,
} from './components';

const StaticPageProps: PageProps = {
  title: 'Guaranteed Hire',
  returnUrl: '/products/guaranteed-hire',
  activeTab: 'Products',
  activeSubTab: 'Guaranteed Hire',
  siteSection: 'products',
  currentPage: 'guaranteed-hire',
  eventName: 'guaranteed-hire-viewed',
};

const GuaranteedHire = () => (
  <StaticPageProvider {...StaticPageProps}>
    <Box background="surface">
      <Stack space="xlarge">
        <Box paddingX="gutter">
          <PageIntro title="Run your business while we help you find the right employee">
            <Text size="large">
              Trust a local market specialist with your most important asset. We
              have local, hands-on support, innovative thinking and insight
              designed to help your business succeed
            </Text>
          </PageIntro>
        </Box>
        <Highlights />
        <Testimonial />
        <SellingPoints />
        <RefundGuarantee />
      </Stack>
    </Box>
  </StaticPageProvider>
);

export default GuaranteedHire;
